import React from 'react';
import About from './About';
import ProductPage from './Technologies';
// import Gallery from './Gallery';
import Contact from './Contact';

import bannerImage from '../Assets/Image/banner1.png';
import { Container } from 'react-bootstrap';
import { Helmet } from "react-helmet";

const HomePage = () => {
  return (
    <div className='mainnav'>

      <Helmet>
        <title>Sense Technologies, Inc. & Sense Natural Products, Inc.</title>
        <meta name="description" content="Sense Technologies, Inc. (OTC:SNSGF) is the parent company of Sense Natural Products, pioneering sensor tech and plant-based solutions for a sustainable future." />
        <meta name="keywords" content="Sense Technologies, Sense Natural Products, sensor technology, plant protein, sustainability, doppler radar, optics, extrusion, expelling, Nebraska" />
        <meta name="author" content="Sense Technologies, Inc." />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Sense Technologies – Innovation for Health & Sustainability" />
        <meta property="og:description" content="Merging smart tech and natural product science to power next-generation solutions in radar, nutrition, and renewable agriculture." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.sensenaturalproducts.com" />
        <meta property="og:image" content="https://www.sensenaturalproducts.com/images/sense-banner.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Sense Technologies – Innovation for Health & Sustainability" />
        <meta name="twitter:description" content="Custom tech and natural product solutions for a better tomorrow." />
        <meta name="twitter:image" content="https://www.sensenaturalproducts.com/images/sense-banner.jpg" />
        <link rel="canonical" href="https://www.sensenaturalproducts.com" />
      </Helmet>

      {/* Hero Section */}
      <div id="home">
        <div className="image-banner">
          <img
            src={bannerImage}
            alt="Sense Technologies Banner"
            className="bg-image"
            style={{ width: '100%', height: '100vh', objectFit: 'cover' }}
          />

          <div className="overlay-wrapper">
            <div className="container h-100">
              <div className="row h-100 align-items-center justify-content-center">
                <div className="col-12 col-md-8 overlay-content text-center sense-heading">
  <h1>Sense Technologies, Inc.</h1>
  <p>& Sense Natural Products, Inc.</p>


                  <div className="mt-3">
                    <a href="#contact" className="btn btn-primary mx-2">Get in Touch</a>
                    <a href="#technologies" className="btn btn-outline-light mx-2">Explore Solutions</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Container className='mt-4'>
          <h1 className='text-center fw-bold' style={{ color: 'rgb(170, 85, 65)' }}>
            "Innovating Health, Technology & Sustainability"
          </h1>
          <p className='text-center fw-bold' style={{ color: '#333' }}>
          Pioneering advanced sensor technologies and nutrient solutions for a better tomorrow.
          </p>
        </Container>
      </div>
      {/* Other sections */}
      <div id="about">
        <About />
      </div>

      <div id="technologies">
        <ProductPage />
      </div>

     

      <div id="contact">
        <Contact />
      </div>
    </div>
  );
};

export default HomePage;
